<template>
<Modal :show="showDeposit" @close="showDeposit = false"  maxWidth="sm">
  <div class="bg-[var(--color-grey9)] text-center p-4">
    <p class="font-bold">
      {{ payload?.action === 'deposit' ? $t('wallet.deposit'): $t('wallet.withdraw') }}
    </p>
    <p class="text-xs mt-1">
      {{ payload?.type?.name }}
    </p>
    <div v-if="payload?.item" class="text-xs mt-2">
      {{ $t('wallet.min') }}: {{ payload.item.min }},  
      {{ $t('wallet.max') }}: {{ payload.item.max }}
    </div>
    <form @submit.prevent class="my-4">
      <SelectField
        v-model="currency"
        :options="getOptions"
        text-attribute="cod"
        value-attribute="_id"
        class="w-full rounded-t-none border-t border-neutral-200"
      />
      <div v-if="payload?.type?.name.toLowerCase() === 'crypto'" class="w-full mt-2 relative bg-[var(--color-grey8)] rounded-lg p-2 flex items-center justify-between">
        <span class="text-sm break-all">
         <strong>{{$t('wallet.wallet')}}:</strong> 
          {{ walletInf }}
        </span>
        <button type="button" @click="copyWallet" class="ml-2 px-1 py-1 text-xs text-white bg-[var(--color-primary1)] rounded hover:bg-[var(--color-primary2)]">
          <img src="/copy.svg" class="w-6 h-6 min-w-6 text-white"/>
        </button>
      </div>
      <TextField 
        type="number"
        v-model.number="amount" 
        class="w-full mt-2" 
        :placeholder="$t('header.10')" 
      />
      <TextField
        v-if="payload?.action === 'withdraw'"
        type="text"
        v-model="note"
        class="w-full mt-2"
        :placeholder="$t('wallet.note')"
      />
    </form>
    <div class="flex items-center gap-2 justify-center mt-6">
      <DefaultButton class="w-full" @click="submit">{{ $t('partials.10') }}</DefaultButton>
    </div>
  </div>
  </Modal>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useAuthStore } from '@/stores/auth';
  import { useI18n } from 'vue-i18n';
  import { useResponseMessageStore } from '@/stores/response_message';
  import Modal from '@/components/Modal.vue';
  import DefaultButton from '@/components/Buttons/DefaultButton.vue';
  import SelectField from '@/components/Form/SelectField.vue';
  import TextField from '@/components/Form/TextField.vue';

  const auth = useAuthStore();
  const showDeposit = ref(false);
  const { getCurrencies } = storeToRefs(auth)
  const responseMessageStore = useResponseMessageStore()
  const amount = ref()
  const { t } = useI18n()
  const payload = ref(null)
  const currency = ref(null) 
  const note = ref('')
  const walletInf = '0x1234abcd5678efgh9012ijkl3456mn' 
  const getOptions = computed(() => getCurrencies.value)

  const copyWallet = () => {
    navigator.clipboard.writeText(walletInf)
  }
  const submit = () => {
    const isCrypto = payload.value?.type?.name?.toLowerCase() === 'crypto'
    const isWithdraw = payload.value?.action === 'withdraw'
    const payloadData = {
      amount: amount.value,
      currency_id: currency.value
    }
    if (isCrypto) { payloadData.wallet = walletInf }
    if (isWithdraw) { payloadData.info = note.value }
    let request
    if (isCrypto && !isWithdraw) request = auth.submitCryptoDeposit(payloadData)
    else if (!isCrypto && !isWithdraw) request = auth.submitDeposit(payloadData)
    else if (isCrypto && isWithdraw) request = auth.submitCryptoWithdraw(payloadData)
    else if (!isCrypto && isWithdraw) request = auth.submitBankWithdraw(payloadData)
    request.then((res) => {
      showDeposit.value = false
      amount.value = null
      note.value = ''
      if (res?.data?.url) window.open(res.data.url, '_blank')
      else if(res?.data?.ok) responseMessageStore.setMessage(res?.data?.message || t('wallet.success'))
    }).catch((err) => {
        console.error(err)
        showDeposit.value = false
        amount.value = null
        note.value = ''
        responseMessageStore.setMessage(
          t(err?.response?.data?.message) || 'Something went wrong'
        )
      })
    }
  const openModal = (data) => {
    payload.value = data
    showDeposit.value = true
    currency.value = getCurrencies.value[0]?._id
  }
  defineExpose({
    openModal
  })
</script>